import {
  getAdjacentOoCaseSidebarItemId,
  getOoCaseSidebarNavigationLabel,
  getVisibleOoCaseSidebarItemIds,
  resolveOoCaseSidebarItemId,
  resolveOoSectionTitleKey,
} from 'components/CaseSidebar';
import { CaseSidebarItemId } from 'components/CaseSidebar/types';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { ooFormNavigationMap } from './ooFormNavigationMap';
import type { OoFormRoute, OoFormRouteContext } from './types';

export function useOoFormMappedRoutes(context: OoFormRouteContext): OoFormRoute {
  const { formatMessage } = useIntl();
  const [searchParams] = useSearchParams();
  const formSectionParam = searchParams.get('section');
  const isNestedRoute = Boolean(searchParams.get('individualId'));
  const visibleSectionIds = getVisibleOoCaseSidebarItemIds(context.sidebarContext);
  const currentSection =
    resolveOoCaseSidebarItemId(formSectionParam, context.sidebarContext) ??
    visibleSectionIds[0] ??
    CaseSidebarItemId.OVERVIEW;

  const FormPage = useMemo(() => ooFormNavigationMap(context)[currentSection] ?? null, [context, currentSection]);

  const useCaseSidebarStepNavigation = Boolean(formSectionParam) && !isNestedRoute;

  const previousSection = useCaseSidebarStepNavigation
    ? getAdjacentOoCaseSidebarItemId(formSectionParam ?? '', context.sidebarContext, 'previous')
    : undefined;

  const nextSection = useCaseSidebarStepNavigation
    ? getAdjacentOoCaseSidebarItemId(formSectionParam ?? '', context.sidebarContext, 'next')
    : undefined;

  const previousLabel = useCaseSidebarStepNavigation
    ? getOoCaseSidebarNavigationLabel(formatMessage, formSectionParam ?? '', context.sidebarContext, 'previous')
    : undefined;

  const nextLabel = useCaseSidebarStepNavigation
    ? getOoCaseSidebarNavigationLabel(formatMessage, formSectionParam ?? '', context.sidebarContext, 'next')
    : undefined;

  return {
    FormPage,
    currentSection,
    sectionTitleKey: resolveOoSectionTitleKey(currentSection, context.sidebarContext),
    previousSection,
    nextSection,
    previousLabel,
    nextLabel,
  };
}
